<div class="flex gap-2" *ngIf="meeting && meeting.startDate && meeting.endDate">
    <i class="text-6 fa-kit fa-talos-clock" [ngClass]="{'text-neutral-300': disabled, 'text-neutral-400': !disabled}"></i>
    <ng-container *ngIf="meeting?.bookingType === 'GroupBooking' && meeting?.groupMeetingSlots?.groupSlots && meeting?.status == 'Tentative'; else meetingTime">
      <span class="text-4 leading-24" [ngClass]="{'text-neutral-300': disabled, 'text-dark': !disabled}">Estimated Length: {{meeting!.interviewDuration}}</span>
    </ng-container>
    <ng-template #meetingTime>
      <span>
        <span class="text-4 leading-24" [ngClass]="{'text-neutral-300': disabled, 'text-dark': !disabled}" *ngIf="meeting.startDate && meeting.endDate">{{formatMeetingTime(meeting!.startDate!)}} - {{formatMeetingTime(meeting!.endDate!)}} </span>
        <span class="text-4 leading-24" [ngClass]="{'text-neutral-300': disabled, 'text-dark': !disabled}" *ngIf="meeting!.interviewDuration">({{meeting!.interviewDuration}})</span>
      </span>
    </ng-template>
</div>
